export enum ResourceLinkType {
  EXTERNAL_REFUND = 'EXTERNAL_REFUND',
  EXTERNAL_TOP_UP = 'EXTERNAL_TOP_UP',
  PAYMENT_REQUEST = 'PAYMENT_REQUEST',
  REFUND = 'REFUND'
}
